export default __webpack_public_path__ + "static/oekotex-8b1bce40267308fedb763d84310a0074.jpg";